import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Input, Modal, Select } from 'antd';
import { addPodcastToQueueSetting, addSkipBeginning, addSkipEnding, podcastAddToQueueGlobal } from '../../actions';
import { getSkipEndingInSec, setIsTyping } from '../../lib/fileUtils';
import { setCustomPlaybackRate } from '../../lib/utils';
const { Option } = Select;
import { MinusCircleOutlined, PlusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';


const options = [
    { 'key': 0, 'label': 'Off' },
    { 'key': 1, 'label': 'Add to the end' },
    { 'key': 2, 'label': 'Add to the beginning' },
];
class PodcastSettings extends Component {

    constructor(props) {
        super(props);
        this.state = { addToQueueType: 0, skipBeginSec: 0, skipBeginSecOrig: 0, skipEndSec: 0, skipEndSecOrig: 0, playbackSpeed: 1, errorMessage: '' };
    }

    componentDidMount() {
        const { subscribedPodcasts, collectionId } = this.props;
        const currentPodcast = subscribedPodcasts[collectionId] || {};
        const skipBegin = currentPodcast['skipBeginningInSeconds'] || 0;
        const skipEnd = getSkipEndingInSec(collectionId); // currentPodcast['skipEndingInSeconds'] || 0;
        console.dir(currentPodcast['skipEndingInSeconds']);
        console.dir(getSkipEndingInSec(collectionId));
        console.dir(skipEnd);
        const playbackSpeed = parseFloat(localStorage.getItem(`appPlaybackRate_${collectionId}`) || 1);
        this.setState({
            skipBeginSec: skipBegin, skipBeginSecOrig: skipBegin,
            addToQueueType: podcastAddToQueueGlobal[collectionId] && podcastAddToQueueGlobal[collectionId]['type'] || 0,
            addToQueueTypeskipEndSec: skipEnd, skipEndSec: skipEnd, skipEndSecOrig: skipEnd, playbackSpeed
        });
    }

    onChangeSkipBeginSec = (event) => {
        if (event.target.value != null) {
            setIsTyping();
            this.setState({ skipBeginSec: event.target.value });
        }
    }
    onChangeSkipEndSec = (event) => {
        if (event.target.value != null) {
            setIsTyping();
            this.setState({ skipEndSec: event.target.value });
        }
    }
    onChangeAddToQueueType = (event) => {
        console.dir(event);
        if (event != null) {
            console.dir(event);
            this.setState({ addToQueueType: event });
        }
    }

    handleCancel = () => {
        this.props.callbackParent();
    }
    handleOk = () => {
        const { skipBeginSec, skipBeginSecOrig, skipEndSec, skipEndSecOrig, playbackSpeed, addToQueueType } = this.state;
        const { userDetails, collectionId } = this.props;
        if (isNaN(skipBeginSec) || skipBeginSec < 0 || skipBeginSec > 30 * 60) {
            this.setState({ errorMessage: `Skip beginning should be a positive number between 0 & ${30 * 60} seconds` });
            return;
        }
        if (skipBeginSecOrig != skipBeginSec) {
            this.props.addSkipBeginning(userDetails['uid'], collectionId, skipBeginSec);
        }
        if (skipEndSecOrig != skipEndSec) {
            addSkipEnding(userDetails['uid'], collectionId, skipEndSec);
        }
        if (podcastAddToQueueGlobal[collectionId] != addToQueueType) {
            addPodcastToQueueSetting(collectionId, addToQueueType);
        }
        setCustomPlaybackRate(collectionId, playbackSpeed);
        this.props.callbackParent();
    }

    changePlaybackSpeed = (increment) => {
        const { playbackSpeed } = this.state;
        console.dir(playbackSpeed);
        console.dir(playbackSpeed + increment);
        const newPlaybackSpeed = Math.round((playbackSpeed + increment) * 10) / 10;
        console.dir(newPlaybackSpeed);
        if (newPlaybackSpeed >= 0.5 && newPlaybackSpeed <= 2.5) {
            this.setState({ playbackSpeed: newPlaybackSpeed });
        }
    }

    showModal = () => {
        Modal.info({
            title: 'Device level setting',
            content: (
                <p>This setting is device dependant and will not auto sync with your other devices. This is because many users listen to the same podcast at different speeds on mobile during commute and on desktop during work.</p>
            ),
            onOk() { },
        });
    };

    render() {
        const { skipBeginSec, skipEndSec, errorMessage, playbackSpeed, addToQueueType } = this.state;
        const { subscribedPodcasts, collectionId } = this.props;
        const currentPodcast = subscribedPodcasts[collectionId] || {};

        if (!currentPodcast || !currentPodcast.collectionId) {
            return (<div>
                <p>Please subscribe to this podcast to edit the settings.</p>
            </div>)
        }

        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p>Skip beginning of each episode (in seconds)</p>
                    <Input type='number' style={{ width: '80px' }} value={skipBeginSec} onChange={this.onChangeSkipBeginSec} />
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p>Skip ending of each episode (in seconds)</p>
                    <Input type='number' style={{ width: '80px' }} value={skipEndSec} onChange={this.onChangeSkipEndSec} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <p>Playback Speed (Device level setting <QuestionCircleOutlined onClick={this.showModal} />)</p>
                    <p><span onClick={this.changePlaybackSpeed.bind(this, -0.1)}><MinusCircleOutlined /> </span> <span style={{ width: '32px', textAlign: 'center', display: 'inline-block' }}>&nbsp;{playbackSpeed}x&nbsp;</span> <span onClick={this.changePlaybackSpeed.bind(this, 0.1)}> <PlusCircleOutlined /></span></p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <p>Queue new episodes automatically</p>
                    <Select style={{
                        width: 200, marginRight: '4px',
                        transform: 'translate(0px, -4px)'
                    }} value={addToQueueType} onChange={(e) => this.onChangeAddToQueueType(e)}>
                        {options.map(option => (
                            <Option key={option.key} value={option.key}>{option.label}</Option>
                        ))}
                    </Select>
                </div>
                <div style={{ padding: '12px', color: 'red' }}>
                    <p>{errorMessage}</p>
                </div>
                <div style={{ textAlign: 'right', marginTop: '2em' }}>
                    <Button type='outline' onClick={this.handleCancel}>Cancel</Button>&nbsp;&nbsp;
                    <Button type='primary' onClick={this.handleOk}>Ok</Button>
                </div>
            </div>
        )
    }
}

PodcastSettings.propTypes = {
    collectionId: PropTypes.any.isRequired,
    callbackParent: PropTypes.func.isRequired,
    subscribedPodcasts: PropTypes.object,
    userDetails: PropTypes.object,
    addSkipBeginning: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        subscribedPodcasts: state.podcastState,
        userDetails: state.userDetails,
        // personalValues: state.personalValues,
        // audioInfo: state.audioState,
        // audioPlayState: state.audioPlayState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        addSkipBeginning: bindActionCreators(addSkipBeginning, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PodcastSettings)
